import { ErrorCode, FileRejection } from 'react-dropzone'

export const getFecImportDroppedFiles = (acceptedFiles: File[], fileRejections: FileRejection[]): File[] => {
  const rejectedFiles = fileRejections
    .filter((fileRejection) => fileRejection.errors.every((error) => error.code !== ErrorCode.TooManyFiles))
    .map((fileRejection) => fileRejection.file)

  return [...acceptedFiles, ...rejectedFiles]
}
